module.exports = __webpack_public_path__ + "static/media/CC_NZ_1st_video_screen.d9d5873d.png";